import AdditionalDocuments from "@features/vessel-register/components/AdditionalDocuments/AdditionalDocuments";
import BunkerBarge from "@features/vessel-register/components/BunkerBarge/BunkerBarge";
import VesselCertificates from "@features/vessel-register/components/VesselCertificates/VesselCertificates";
import VesselInformation from "@features/vessel-register/components/VesselInformation/VesselInformation";
import VesselOwnership from "@features/vessel-register/components/VesselOwnership/VesselOwnership";
import VesselParticulars from "@features/vessel-register/components/VesselParticulars/VesselParticulars";
import VesselRegistrationContainer from "@features/vessel-register/components/VesselRegistrationContainer";
import VesselStatus from "@pages/vessel-management/vessel-status/VesselStatus";
import VesselsPage from "@pages/vessel-management/VesselsPage";
import { paths } from "@utils/navigation";
import { type AppRoute } from "../types";

export const getVesselManagementRoutes = (): AppRoute => ({
  path: paths.vesselManagement.index,
  protected: true,
  requiredPermissions: ["hasVesselRegistrationAccess"],
  children: [
    { index: true, element: <VesselsPage /> },
    { path: paths.vesselManagement.vesselStatus, element: <VesselStatus /> },
    {
      path: paths.vesselManagement.register,
      element: <VesselRegistrationContainer />,
      children: [
        {
          index: true,
          redirectTo: paths.vesselManagement.vesselInformation,
        },
        {
          path: paths.vesselManagement.vesselInformation,
          element: <VesselInformation />,
        },
        { path: paths.vesselManagement.vesselType, element: <VesselParticulars /> },
        { path: paths.vesselManagement.vesselOwnership, element: <VesselOwnership /> },
        { path: paths.vesselManagement.vesselCertificates, element: <VesselCertificates /> },
        { path: paths.vesselManagement.additionalDocuments, element: <AdditionalDocuments /> },
        { path: paths.vesselManagement.bunkerBarge, element: <BunkerBarge /> },
      ],
    },
  ],
});
